<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="权益申请"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onSubmit">
        <div class="batch-item">
          <!--   球杆编码  代理商手填，普通用户选择   -->
          <van-field
              v-if="userType === '02'"
              v-model="formData.oldNumber"
              name="number"
              label="球杆编码"
              placeholder="请手动输入球杆编码"
              class="search-input"
              :rules="[{ required: true }]"
          />

          <!-- 普通用户：直接赋值 + 只读 -->
          <van-field
              v-else
              readonly
              name="number"
              :value="formData.oldNumber"
              label="球杆编码"
              placeholder="球杆编码"
              class="search-input"
              :rules="[{ required: true, message: '请选择球杆编码' }]"
          />

          <!-- 只有普通用户才显示选择器 -->
          <van-popup v-if="userType !== '02'" v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
          </van-popup>

          <van-field v-if="formData.oldNumber && userType !== '02'" readonly v-model="formData.oldBrand" name="oldBrand" label="品牌" />
          <van-field v-if="formData.oldNumber && userType !== '02'" readonly v-model="formData.oldModel" name="oldModel" label="型号" />
          <!--   权益     -->
          <van-field
              readonly
              clickable
              name="newName"
              :value="formData.newName"
              :label="typeName+'品类'"
              :placeholder="'点击选择球杆'+typeName+'品类'"
              @click="openBenefitsPicker"
              class="search-input"
              :rules="[{ required: true}]"
          />
          <van-popup v-if="showBenefitsPicker" v-model="showBenefitsPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectBenefitsOptions"
                @confirm="onBenefitsConfirm"
                @cancel="showBenefitsPicker = false"
            />
          </van-popup>

          <!-- 置换说明（文字红色） -->
          <van-field
              v-if="formData.equityIntro"
              readonly
              label="置换说明"
              :value="formData.equityIntro"
              type="textarea"
              rows="2"
              class="red-text-field"
          />

          <van-field v-if="isChildren && type == '1'" name="isColor" label="是否跨色置换">
            <template #input>
              <van-radio-group v-model="formData.isColor" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
              v-if="isChildren && type == '1' && formData.isColor=='1' "
              readonly
              clickable
              name="colorName"
              :value="formData.colorName"
              label="跨色品类"
              placeholder="点击选择跨色品类"
              @click="openColorPicker"
              class="search-input"
              :rules="[{ required: true}]"
          />
          <van-popup v-if="showColorPicker" v-model="showColorPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectColorOptions"
                @confirm="onColorConfirm"
                @cancel="showColorPicker = false"
            />
          </van-popup>

          <van-field name="fileList" label="旧杆图片"  :rules="[{ required: true, message: '请上传旧杆图片' }]">
            <template #input>
              <van-uploader v-model="formData.fileList" multiple :max-count="3" />
            </template>
          </van-field>

          <!-- 新增：图片上传说明 -->
          <div class="upload-tip">
            请上传球杆编码清晰图及其他凭证
          </div>

          <van-field v-model="formData.phonenumber" name="phonenumber" label="联系电话" placeholder="请输入联系电话" :rules="[{ validator:telValidator }]"/>
          <van-field v-model="formData.address" name="address" label="通讯地址" placeholder="请输入通讯地址" type="textarea" rows="3" />

          <div style="margin: 16px;">
            <van-button class="submit-btn" round block type="info" native-type="submit">提交申请</van-button>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {Dialog, Toast} from "vant";
import { areaList } from '@vant/area-data';
import {
  memberEquitiesUse, memberEquitiesUseCheck, memberInformation,
  seriesOfCueSticks,
} from "@/api/mine";
import {benefitsSubmit} from "@/api/sales";

export default {
  data(){
    return {
      // 表单数据
      formData: {
        phonenumber: '',       // 联系电话
        address: '',     // 通讯地址
        oldNumber: '',   // 球杆编号
        oldBrandCode: '',//品牌
        oldBrand: '',
        oldModelCode: '',//型号
        oldModel: '',
        newId: '',//福利id
        newName: '',//福利名称
        equityIntro: '', // 置换说明
        type: '',//类型 1、置换 2、翻新

        isColor: '0',
        colorId: '',//跨色福利id
        colorName: '',//跨色福利名称
        fileList: [],
      },

      seriesId:'',
      type:'',
      typeName:'',
      selectOptions: [],
      showPicker: false,

      //权益接口返回数据
      benefitsList: [],
      //权益下拉值
      selectBenefitsOptions: [],
      showBenefitsPicker: false,
      //跨色权益

      isChildren: false,
      selectColorOptions: [],
      showColorPicker: false,

      myClubList:[],
      selectClubForm:{},

      provinceValue: '',
      showArea: false,
      areaList,
      fileList: [],
      userType: '', //用户类别：01-会员、02-代理商、00-后台用户
      clubValueNo: '',
    }
  },
  async created() {
    // 先拿用户信息
    await this.getUserInfo();
    // 再处理路由参数
    this.handleRouteQuery();
  },
  methods: {
    handleRouteQuery() {
      const query = this.$route.query;
      const { seriesId, type, typeName, clubValue } = query;

      // 接收球杆编码
      const receivedClubValue = clubValue || '';
      this.clubValueNo = receivedClubValue;
      this.typeName = typeName;

      if (seriesId && type) {
        this.seriesId = seriesId;
        this.type = type;

        // 普通用户：直接赋值，只读
        if (this.userType !== '02') {
          this.formData.oldNumber = receivedClubValue;
          this.selectProductByUser(seriesId);
        }

      } else {
        Toast("参数不能为空");
      }
    },

    // 获取用户信息
    async getUserInfo() {
      try {
        const res = await memberInformation();
        if (res.code === 200 && res.data) {
          this.userType = res.data.userType;
        }
      } catch (err) {}
    },

    //权益点击事件
    openBenefitsPicker(){
      if(!this.formData.oldNumber){
        Toast("请先选择/输入球杆编码！");
      }else{
        this.memberEquitiesUse();
      }
    },
    //打开跨色点击事件
    openColorPicker(){
      if(!this.formData.oldNumber){
        Toast("请先选择球杆编码！");
      }else if(!this.formData.newId){
        Toast("请先选择球杆品类！");
      }else{
        const filterList = this.benefitsList.filter(item => item.id === this.formData.newId)[0].children ||[];
        if(filterList){
          filterList.forEach(item => {
            this.selectColorOptions.push({
              value: item.relationId,
              text: item.name,
            })
          })
        }
        this.showColorPicker = true;
      }
    },
    //获取福利
    memberEquitiesUse(){
      memberEquitiesUse(this.type,this.seriesId,this.formData.oldNumber,).then(res => {
        if (res.code === 200) {
          if(res.data){
            this.showBenefitsPicker = true;
            this.selectBenefitsOptions = [];
            this.benefitsList = res.data;
            res.data.forEach(item => {
              item.isChildren = !!(item.children && item.children.length>0);
              this.selectBenefitsOptions.push({
                text: item.name,
                value: item.id,
                equityIntro: item.equityIntro || '',
              });
            })
          }
        } else {
          this.showBenefitsPicker = false;
          this.showDialogMsg(res.returnMsg)
        }
      })
    },
    //权益校验
    async memberEquitiesUseCheck(benefits,  number){
      return await new Promise((resolve) => {
        memberEquitiesUseCheck(benefits, number).then(res => {
          if (res.code === 200) {
            resolve(true);
          } else {
            this.showDialogMsg(res.returnMsg);
            resolve(false);
          }
        })
      })
    },
    //获取当前登录人名下注册登记的球杆 —— 只有非代理商才调用
    selectProductByUser(seriesId){
      if(this.userType === '02') return;
      seriesOfCueSticks(seriesId).then(res => {
        if (res.code === 200) {
          if(res.data) {
            this.myClubList = res.data;
            this.selectOptions = res.data.map(item => item.value);

            // 根据 clubValue 自动匹配品牌型号
            const club = this.myClubList.find(item => item.value === this.formData.oldNumber);
            if (club) {
              this.formData.oldBrand = club.brand;
              this.formData.oldModel = club.model;
              this.formData.oldBrandCode = club.brandCode;
              this.formData.oldModelCode = club.modelCode;
            }
          }
        } else {
          this.showDialogMsg(res.returnMsg)
        }
      })
    },
    //手机号正则校验
    telValidator(val) {
      if(val){
        const reg = /^1[3-9]\d{9}$/;
        return reg.test(val);
      }
      return false;
    },
    //顶部标题栏返回事件
    onClickLeft() {
      // this.$router.push('/app_benefits');

      this.$router.push({
        path: '/app_benefits',
        query: { clubValue: this.clubValueNo }
      });
    },
    //序列号确认事件
    onConfirm(value) {
      this.formData.oldNumber = value;
      this.showPicker = false;
      this.selectClubForm = this.myClubList.find(item => item.value === value) || {};
      if(this.selectClubForm){
        this.formData.oldBrandCode = this.selectClubForm.brandCode;
        this.formData.oldBrand = this.selectClubForm.brand;
        this.formData.oldModelCode = this.selectClubForm.modelCode;
        this.formData.oldModel = this.selectClubForm.model;
      }
    },
    //球杆品类确认事件
    async onBenefitsConfirm(value, index) {
      const selectedItem = this.selectBenefitsOptions[index];
      this.showBenefitsPicker = false;

      const flag = await this.memberEquitiesUseCheck(selectedItem.value,this.formData.oldNumber);
      if(flag){
        const benefits = this.benefitsList.find(item => item.id === selectedItem.value) || {};
        this.isChildren = benefits.isChildren || false;

        this.formData.newId = selectedItem.value;
        this.formData.newName = selectedItem.text;
        this.formData.equityIntro = selectedItem.equityIntro || '';
      }


    },
    //球杆跨色品类确认事件
    async onColorConfirm(value, index) {
      const selectedItem = this.selectColorOptions[index];
      const flag = await this.memberEquitiesUseCheck(selectedItem.value,this.formData.oldNumber);
      if(flag && selectedItem){
        this.formData.colorId = selectedItem.value;
        this.formData.colorName = selectedItem.text;
      }
      this.showColorPicker = false;
    },

    //提交申请
    async onSubmit(){
      const formData = new FormData();
      formData.append('phonenumber', this.formData.phonenumber);
      formData.append('address', this.formData.address);
      formData.append('oldNumber', this.formData.oldNumber);
      formData.append('oldBrandCode', this.formData.oldBrandCode);
      formData.append('oldBrand', this.formData.oldBrand);
      formData.append('oldModelCode', this.formData.oldModelCode);
      formData.append('oldModel', this.formData.oldModel);

      if(this.formData.isColor == '1'){
        if(this.formData.colorId){
          formData.append('newId', this.formData.colorId);
        }
      }else{
        formData.append('newId', this.formData.newId);
      }
      formData.append('type', this.type);

      this.formData.fileList.forEach(item => {
        if (item.file) {
          formData.append('file', item.file);
        }
      });

      const res = await benefitsSubmit(formData);
      if(res.code==200){
        Toast("提交申请成功，请您等待售后联系！")
        setTimeout(() => {
          this.$router.push({
            path: '/app_benefits',
          })
        }, 2000);
      }else{
        Toast(res.returnMsg)
      }
    },

    showDialogMsg(message){
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true
      });
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
::v-deep .van-tab__pane{
  color: #0f0f0f !important;
}
.van-radio--horizontal{
  margin-bottom: 10px;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
}
.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
}
.submit-btn{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}

/* 置换说明文字红色 */
::v-deep .red-text-field .van-field__control {
  color: red !important;
  font-weight: 500;
}

/* 图片上传提示语 */
.upload-tip {
  font-size: 14px;
  color: red;
  margin: 8px 0 8px 0;
  padding-left: 12px;
  font-weight: 500;
}
</style>